module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_2.db7fa9c8.pdf";